import * as jsPdf from 'jspdf';
import DisplayRounding from '../DisplayRounding';


const dr = DisplayRounding;

interface ITextArrayItem{
    cols: number;
    text: string;
}
export const fitTextInBox = (text:string, width: number, mudReport:jsPdf) => {
    let textWidth = mudReport.getTextWidth(text);
    let tempText = text;
    while (textWidth > width) {
        tempText = tempText.substr(0, tempText.length - 1);
        textWidth = mudReport.getTextWidth(tempText);
    }
    return tempText;
};

export const textCenteredInBox = (text: string, left: number, top: number, width: number, height: number, mudReport: jsPdf) => {
    const tempLeft = left + width / 2;
    const tempTop = top + height / 2;
    const displayText = fitTextInBox(text, width, mudReport);
    mudReport.text(displayText, tempLeft, tempTop, { align: 'center', baseline: 'middle'});
};

export const textLeftJustifiedInBox = (text: string, left: number, top: number, width: number, height: number, mudReport: jsPdf) => {
    const tempTop = top + height / 2;
    const tempLeft = left + 1;
    const displayText = fitTextInBox(text, width - 2, mudReport);
    mudReport.text(displayText, tempLeft, tempTop, { align: 'left', baseline: 'middle'});
};

export const textRightJustifiedInBox = (text: string, left: number, top: number, width: number, height:number, mudReport: jsPdf) => {
    const tempTop = top + height / 2;
    const tempLeft = left + width - 2;
    const displayText = fitTextInBox(text, width - 3, mudReport);
    mudReport.text(displayText, tempLeft, tempTop, { align: 'right', baseline: 'middle'});
};

export const textArrayInBoxes = (textArray: Array<Array<number | string | ITextArrayItem | undefined> | undefined>, left: number, top: number, width: number, height: number, align: string, mudReport: jsPdf) => {
    const numBoxesY = textArray.length;
    const boxHeight = height / numBoxesY;
    let tempTop = top;

    for(const textRow of textArray) {
        if (textRow === undefined) {
            tempTop += boxHeight;
            continue;
        }
        let numBoxesX = 0;
        if(typeof textRow[0] === 'object') {
            textRow.forEach((value: ITextArrayItem) => {
                numBoxesX += value.cols;
            });
        } else {
            numBoxesX = textRow.length;
        }
        const boxWidth = width / numBoxesX;
        let tempLeft = left;
        for (const text of textRow) {
            if (typeof text === 'object') {
                // handle object { text: string, cols: number }
                if (text.text !== undefined && typeof text.cols === 'number') {
                    const tempBoxWidth = text.cols * boxWidth;
                    const tempText = typeof text.text === 'number' ? dr.RoundString(text.text) : text.text;
                    if (align === 'center') {
                        textCenteredInBox(tempText, tempLeft, tempTop, tempBoxWidth, boxHeight, mudReport);
                    } else if (align === 'left') {
                        textLeftJustifiedInBox(tempText, tempLeft, tempTop, tempBoxWidth, boxHeight, mudReport);
                    } else if (align === 'right') {
                        textRightJustifiedInBox(tempText, tempLeft, tempTop, tempBoxWidth, boxHeight, mudReport);
                    }
                    tempLeft += tempBoxWidth;
                }
            } else if (text !== undefined && text !== '') {
                const tempText = typeof text === 'number' ? dr.RoundString(text) : text;
                if (align === 'center') {
                    textCenteredInBox(tempText, tempLeft, tempTop, boxWidth, boxHeight, mudReport);
                } else if (align === 'left') {
                    textLeftJustifiedInBox(tempText, tempLeft, tempTop, boxWidth, boxHeight, mudReport);
                } else if (align === 'right') {
                    textRightJustifiedInBox(tempText, tempLeft, tempTop, boxWidth, boxHeight, mudReport);
                }
                tempLeft += boxWidth;
            } else {
                tempLeft += boxWidth;
            }
        }
        tempTop += boxHeight;
    }
};


// WEBPACK FOOTER //
// ./src/Services/Pdf/PopulateDataMethods.ts